export default "/fonts/vendor/@fontsource/inter/files/inter-cyrillic-400-normal.woff2?514f4123b1effd5ed0d8f430f349d54d";